import styled from 'styled-components';
import { MQUERY } from 'common/constants';

export const VideoChaptersTitle = styled.h3`
    font-size: var(--default);
    margin-top: 0;
    margin-bottom: 1.8rem;
`;

export const ChaptersWrapper = styled.div`
    display: flex;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 1rem;
    overflow-x: auto;
    overflow-y: hidden;

    @media ${MQUERY.DESKTOP_SMALL} {
        scroll-snap-type: none;  
    }
`;

export const ChapterTime = styled.span`
    color: var(--white);
    font-size: var(--link);
    font-weight: var(--bold);
    padding: .2rem .4rem;
    border-radius: 3rem;
    display: block;
    transition: background-color .3s;
    z-index: 1;
`;

export const ChapterTitle = styled.span`
    font-size: var(--meta);
    font-weight: var(--regular);
    line-height: 1.8;
    max-width: 90%;
    text-align: left;
    transition: text-decoration .3s;
`;

export const VideoChaptersBtn = styled.button`
    height: 100%;
    width: 100%;
    max-width: 26.8rem;
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    padding: 0;

    &:after {
        background-color: ${ ( { darkModeOn } ) => ( darkModeOn ? 'var(--neutral700)' : 'var(--neutral400)' )};
        content: '';
        width: 100%;
        height: .2rem;
        position: absolute;
        top: 1rem;
        right: 0;
        transition: background-color .3s;
    }

    ${ChapterTime} {
        background-color: ${({ darkModeOn }) => ( darkModeOn ? 'var(--neutral650)' : 'var(--neutral400)' )};
    }

    ${ChapterTime},
    &:after {
        color: ${({ isActive }) => ( isActive ? 'var(--primary)' : '')};
        background: ${({ isActive }) => ( isActive ? 'var(--button)' : '')};
    }

    &:hover {

        ${ChapterTime},
        &:after {
            color: var(--primary);
            background-color: var(--button);
        }
        
        ${ChapterTitle} {
            text-decoration: underline;
        }
    }

    @media ${MQUERY.DESKTOP_SMALL} {
        ${({ chaptersLength } ) => ( chaptersLength  && `max-width: calc(100%/${chaptersLength})` )};
    }
`;

export const VideoChapters = styled.div`
    padding: 2.4rem var(--widget-padding-mobile) 0;
    position: relative;

    &:after {
        background: ${({ darkModeOn }) => ( `linear-gradient(${ darkModeOn ? '270deg, var(--neutral800) 0%, rgba(32, 40, 67, 0) 94.87%' : '270deg, #F8F5F4 0%, rgba(248, 245, 244, 0) 94.87%'})` )};
        content: '';
        height: 12rem;
        width: 8.1rem;
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 1;
    }

    @media ${MQUERY.DESKTOP_SMALL} {
        padding: 1.2rem var(--widget-padding-desktop) 3.2rem;

        &:after {
            display: none;
        }
    }
`;